import { render, staticRenderFns } from "./VehicleNew.vue?vue&type=template&id=f748045e"
import script from "./VehicleNew.vue?vue&type=script&lang=js"
export * from "./VehicleNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f748045e')) {
      api.createRecord('f748045e', component.options)
    } else {
      api.reload('f748045e', component.options)
    }
    module.hot.accept("./VehicleNew.vue?vue&type=template&id=f748045e", function () {
      api.rerender('f748045e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/vehicle/VehicleNew.vue"
export default component.exports